<template>
    <div>
        <ul>
            <li
                v-for="option in selectOptions"
                :key="option.id"
            >
                <CategoryFilterOption
                    :active="option.id === attributeId"
                    :image="option.image"
                    @click="handleInputChange(option.id)"
                >
                    {{ option.name }}
                </CategoryFilterOption>
            </li>
        </ul>
    </div>
</template>

<script>
import Select from '@/components/Select';
import CategoryFilterOption from '@/components/CategoryFilterOption.vue';

export default {

    components: {
        CategoryFilterOption,
        Select,
    },

    props: {
        options: {
            type: Array,
            required: true,
        },
        attributeId: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            defaultOption: {
                id: 0,
                name: 'All',
            },
        };
    },

    computed: {
        selectOptions() {
            return [
                this.defaultOption,
                ...this.options,
            ];
        },
    },

    methods: {
        handleInputChange(optionId) {
            // emit null if the default option is selected
            this.$emit('change', optionId === this.defaultOption.id ? null : optionId);
        },
    },

};
</script>

<style lang="scss" scoped>
select {
    @apply bg-white border border-primary rounded-full px-4 h-10 flex items-center text-sm font-semibold text-primary;
    border-width: 2px;
    -webkit-appearance: none;
}
</style>
